import React, { Component } from 'react';

import './style.css';

class MyButton extends Component {
  render() {
    const {
      small,
      error,
      color,
      xsmall,
      xxsmall,
      primary,
      success,
      disabled,
      children,
      secondary,
      transparent,
    } = this.props;

    const styles = `my-button
      ${small ? 'small' : ''}
      ${error ? 'error' : ''}
      ${xsmall ? 'xsmall' : ''}
      ${xxsmall ? 'xxsmall' : ''}
      ${success ? 'success' : ''}
      ${primary ? 'primary' : ''}
      ${disabled ? 'disabled' : ''}
      ${secondary ? 'secondary' : ''}
      ${transparent ? 'transparent' : ''}`;

    return (
      <button className={styles}>
        <div className="my-button-label" style={{ color: color ? color : '' }}>
          {children}
        </div>
      </button>
    );
  }
}

export default MyButton;
